import { Icon, IconProps } from './Icon';

export const TodayStopIcon = ({ ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 40 40"
  >
    <defs>
      <linearGradient
        id="paint0_linear_5612_42861"
        x1="31.1111"
        y1="5.08475"
        x2="-5.73956"
        y2="32.1996"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#15C3FF" />
        <stop
          offset="1"
          stopColor="#8DF4DB"
        />
      </linearGradient>
      <clipPath id="clip0_5612_42861">
        <rect
          width="40"
          height="40"
          fill="white"
        />
      </clipPath>
    </defs>
    <g clipPath="url(#clip0_5612_42861)">
      <rect
        width="40"
        height="40"
        rx="20"
        fill="#C2E2FF"
      />
      <rect
        width="40"
        height="40"
        rx="20"
        fill="url(#paint0_linear_5612_42861)"
      />
      <path
        d="M20.1753 13.0166C20.8459 16.6566 23.694 19.5048 27.3341 20.1753C23.694 20.8459 20.8459 23.694 20.1753 27.3341C19.5048 23.694 16.6566 20.8459 13.0166 20.1753C16.6566 19.5048 19.5048 16.6566 20.1753 13.0166Z"
        fill="#FEFEFE"
      />
    </g>
  </Icon>
);
